import { combineReducers } from 'redux';
import { createFetchReducer, FetchingReducerState } from 'store/setLocalStore';
import { GetPayments_guarantor_payments as Payment } from 'services/billing/__generated__/GetPayments';
import {
  DETAIL_DOWNLOAD,
  PAYMENT_DOWNLOAD,
  GET_ENCOUNTER_DETAIL,
  GET_PAYMENT_LIST,
  GET_BILLS,
  GET_BILLING_SUMMARY,
  GET_COLLECTIONS_SUMMARY,
  GET_PAYMENT_DETAIL,
  GET_PAYMENT_PLAN_SUMMARY,
  GET_PAYMENTS_SUMMARY,
  GET_HSA_SUMMARY,
  GET_FINANCIAL_ASSISTANCE_SUMMARY,
  GET_FINANCIAL_ASSISTANCE_APPLICATIONS,
  GET_FINANCIAL_ASSISTANCE_APPLICATION,
  GET_BILLING_VISIT_SUMMARY_DETAILS,
  GET_ALL_COLLECTIONS_SUMMARY
} from './actions';
import {
  Bills,
  BillingSummary,
  CollectionsSummary,
  EncounterDetail,
  HsaSummary,
  PaymentDetailSummary,
  PaymentListItem,
  PaymentsPlanSummary,
  PaymentsSummary,
  FinancialAssistanceSummary,
  FinancialAssistanceApplication,
  BillingVisitSummary,
  CollectionsDetails
} from './types';

export type BillsState = FetchingReducerState<Bills>;
export type BillingSummaryState = FetchingReducerState<BillingSummary>;
export type CollectionsSummaryState = FetchingReducerState<CollectionsSummary>;
export type DetailDownloadState = FetchingReducerState<any>;
export type EncounterDetailState = FetchingReducerState<EncounterDetail>;
export type HsaSummaryState = FetchingReducerState<HsaSummary>;
export type PaymentDetailState = FetchingReducerState<PaymentDetailSummary>;
export type PaymentDownloadState = FetchingReducerState<any>;
export type PaymentPlanSummaryState = FetchingReducerState<PaymentsPlanSummary>;
export type PaymentsListState = FetchingReducerState<PaymentListItem[]>;
export type PaymentsSummaryState = FetchingReducerState<PaymentsSummary>;
export type FinancialAssistanceSummaryState = FetchingReducerState<FinancialAssistanceSummary>;
export type FinancialAssistanceApplicationState = FetchingReducerState<
  FinancialAssistanceApplication
>;
export type FinancialAssistanceApplicationListState = FetchingReducerState<
  FinancialAssistanceApplication[]
>;
export type BillingVisitSummaryState = FetchingReducerState<BillingVisitSummary>;
export type CollectionsDetailsState = FetchingReducerState<CollectionsDetails>;

export interface BillingState {
  bills: BillsState;
  billingSummary: BillingSummaryState;
  detailsDownload: DetailDownloadState;
  encounterDetail: EncounterDetailState;
  financialAssistanceSummary: FinancialAssistanceSummaryState;
  financialAssistanceApplications: FinancialAssistanceApplicationListState;
  financialAssistanceApplication: FinancialAssistanceApplicationState;
  hsaSummary: HsaSummaryState;
  paymentDetail: PaymentDetailState;
  paymentPlanSummary: PaymentPlanSummaryState;
  paymentsDownload: PaymentDownloadState;
  paymentsList: PaymentsListState;
  paymentsSummary: PaymentsSummaryState;
  billingVisitSummary: BillingVisitSummaryState;
  collectionsDetails: CollectionsDetailsState;
}

export interface PaymentState {
  paymentDetailState: PaymentDetailState;
}
export interface EncounterState {
  encounterDetail: EncounterDetailState;
}

export default combineReducers({
  bills: createFetchReducer<Bills>(GET_BILLS),
  billingSummary: createFetchReducer<BillingSummary>(GET_BILLING_SUMMARY),
  collectionsSummary: createFetchReducer<CollectionsSummary>(GET_COLLECTIONS_SUMMARY),
  detailsDownload: createFetchReducer(DETAIL_DOWNLOAD),
  encounterDetail: createFetchReducer<EncounterDetail>(GET_ENCOUNTER_DETAIL),
  financialAssistanceSummary: createFetchReducer<FinancialAssistanceSummary>(
    GET_FINANCIAL_ASSISTANCE_SUMMARY
  ),
  financialAssistanceApplications: createFetchReducer<FinancialAssistanceApplication[]>(
    GET_FINANCIAL_ASSISTANCE_APPLICATIONS
  ),
  financialAssistanceApplication: createFetchReducer<FinancialAssistanceApplication>(
    GET_FINANCIAL_ASSISTANCE_APPLICATION
  ),
  hsaSummary: createFetchReducer<HsaSummary>(GET_HSA_SUMMARY),
  paymentDetail: createFetchReducer<PaymentDetailSummary>(GET_PAYMENT_DETAIL),
  paymentPlanSummary: createFetchReducer<PaymentsPlanSummary>(GET_PAYMENT_PLAN_SUMMARY),
  paymentsDownload: createFetchReducer(PAYMENT_DOWNLOAD),
  paymentsList: createFetchReducer<Payment[]>(GET_PAYMENT_LIST),
  paymentsSummary: createFetchReducer<PaymentsSummary>(GET_PAYMENTS_SUMMARY),
  billingVisitSummary: createFetchReducer<BillingVisitSummary>(GET_BILLING_VISIT_SUMMARY_DETAILS),
  collectionsDetails: createFetchReducer<CollectionsDetails>(GET_ALL_COLLECTIONS_SUMMARY)
});
